<ng-container *ngIf="!open">
    <div class="left-header">
        <options class="show-label bar baroptions no-title actions all-width" [optionstrip]="gateOptions"
            (clickOption)="clickGateOption.emit($event)"></options>
    </div>
    <div class="gate-routes">
        <shared-forklift-left-route *ngFor="let route of selectedGatePlates | orderbyaccesscontrolgateplatedto:true" [value]="route"
            (clickRoute)="clickRoute.emit($event)"></shared-forklift-left-route>
    </div>
</ng-container>
<div class="gates-body" *ngIf="open">
    <div class="gate-column" *ngFor="let gate of gates | sortBy: 'gateOrder'">
        <div class="gate-header">{{ gate.gateName }}</div>
        <div class="gate-routes">
            <shared-forklift-left-route *ngFor="let route of gate.plates | orderbyaccesscontrolgateplatedto:true" [value]="route"
                (clickRoute)="clickRoute.emit($event)"></shared-forklift-left-route>

        </div>
    </div>
</div>